export default __webpack_public_path__ + "static/media/Oluwole Ogunlade.50855900.jpg";